var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.className
  }, [_c('div', {
    staticClass: "head-priamry mb-n20 mb-lg-n26 position-relative rounded w-180px w-lg-340px mx-auto",
    staticStyle: {
      "background-color": "#6f97f3"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.tit) + " ")])]), _c('div', {
    staticClass: "rounded border pa-20 px-md-30 pa-lg-40 pt-30 pt-md-40 pt-lg-66"
  }, [_vm._t("default")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }